const isSafari = navigator.vendor === 'Apple Computer, Inc.';

export default isSafari;